type Primitive = string | number | boolean | null | undefined;

type FieldPaths<T> = T extends Primitive
  ? never
  : T extends unknown[]
    ? keyof T extends string
      ? keyof T
      : never
    : keyof T extends string
      ? {
          [K in keyof T & string]:
            | K
            | (T[K] extends Primitive
                ? never
                : T[K] extends unknown[]
                  ? `${K}` | `${K}.${keyof T[K] & string}`
                  : `${K}.${FieldPaths<T[K]>}`);
        }[keyof T & string]
      : never;

export type FieldMask<T> = FieldPaths<T> | FieldPaths<T>[];

export function fieldMask<T>(mask: FieldMask<T>): string {
  return Array.isArray(mask) ? mask.join(',') : mask;
}
